@if (loadingService.isLoading$ | async) {
  <mat-progress-bar mode="indeterminate" class="global-loading-bar" />
}
@if (showNavbar()) {
  <a class="wfm-skip-link" href="#conteudo" (click)="skipToContent($event)">Pular para o conteúdo</a>
  <div class="wfm-shell">
    <app-sidebar />
    <main class="wfm-shell-main" id="conteudo" tabindex="-1">
      <app-breadcrumb />
      <router-outlet />
    </main>
    <app-business-guide-drawer />
    <app-command-palette />
  </div>
} @else {
  <router-outlet />
}
